import React, { useState, useEffect } from 'react';
import Fnc from '../library/Functions'
import InlineFieldLoader from './InlineFieldLoader';
import './DefInp.css';

function DefInp(props) {

  const [loading, setLoading] = useState(null);
  const [showError, setShowError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);


  //const [, updateState] = React.useState();
  //const forceUpdate = React.useCallback(() => updateState({}), []);

  useEffect(() => {
    // Similar to componentDidMount and componentDidUpdate:

  }, [props.forceDisabled]); //empty array => chiama solo una volta. Senza la chiama ad ogni cambiamento

  function onBlur(e) {
    let val = e.target.value;

    setLoading(true);

    if (props.required) {

      if (val && val.length > 0) {
        //non ho un valore vuoto
        props.callback(new Fnc.Ret(Fnc.EnmGen.OK, val));
        setShowError(false);
        setErrorMsg(null);
      } else {
        setShowError(true);
        setErrorMsg(Fnc.EnmGen.EMPTY.msg);
        props.callback(new Fnc.Ret(Fnc.EnmGen.EMPTY));
      }

    } else {
      props.callback(new Fnc.Ret(Fnc.EnmGen.OK, val));
      setShowError(false);
      setErrorMsg(null);
    }

    setLoading(false);

}
  return (
    <>
      <input
			className={`form-control ${(props.forceDisabled === true) && "disabled"} ${showError ? "iol-field--error" : ""}`}
			disabled={props.forceDisabled} 
			type="text"
			id={props.id} 
			placeholder={props.example || "Es. Inserisci un valore"}
			aria-invalid={showError}
			key={props.value} 
			defaultValue={props.value} 
			onBlur={onBlur} 
			autoComplete="on"
			/>
      <span
			className={`placeholder-text ${showError && "lblError"} ${(props.forceDisabled === true) && "disabled"}`}>
			{props.required && <span className="checkout-required-marker" aria-hidden="true">*</span>} {props.label}
			</span>
      <InlineFieldLoader visible={loading} />
      {showError && <div className="iol-error-label">{errorMsg}</div>}
    </>
  );
}

export default DefInp;
